import '.hh{width:2.75rem;}.ssr-plugin'
import '.ex{height:1.5rem;}.ssr-plugin'
import '.fj{border-radius:1rem;}.ssr-plugin'
import '.ay{border:none;}.ssr-plugin'
import '.ac{position:relative;}.ssr-plugin'
import '.a1{cursor:pointer;}.ssr-plugin'
import '.p{padding:0px;}.ssr-plugin'
import '.af{flex-shrink:0;}.ssr-plugin'
import '.be{position:absolute;}.ssr-plugin'
import '.hi{top:0.125rem;}.ssr-plugin'
import '.gn{width:1.25rem;}.ssr-plugin'
import '.go{height:1.25rem;}.ssr-plugin'
import '.gp{border-radius:50%;}.ssr-plugin'
import '.v{background-color:var(--palette-white);}.ssr-plugin'
import '.hj{transition:left 0.2s ease;}.ssr-plugin'
import '.cb{display:inline-flex;}.ssr-plugin'
import '.s{flex-direction:row;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.ai{justify-content:center;}.ssr-plugin'
import '.u{gap:0.5rem;}.ssr-plugin'
import '.fz{height:3rem;}.ssr-plugin'
import '.du{padding-left:1.5rem;}.ssr-plugin'
import '.hk{padding-right:1.5rem;}.ssr-plugin'
import '.hl{padding-top:0.8125rem;}.ssr-plugin'
import '.hm{padding-bottom:0.8125rem;}.ssr-plugin'
import '.hn{border-radius:1.875rem;}.ssr-plugin'
import '.ho{border:2px solid var(--brand-secondary);}.ssr-plugin'
import '.a3{color:var(--brand-secondary);}.ssr-plugin'
import '.ct{background:transparent;}.ssr-plugin'
import '.hp{font-weight:600;}.ssr-plugin'
import '.cq{font-size:1.125rem;}.ssr-plugin'
import '.b4{color:inherit;}.ssr-plugin'
import '.ef{gap:0.375rem;}.ssr-plugin'
import '.hq{padding:0.375rem 0.625rem;}.ssr-plugin'
import '.fa{border-radius:0.5rem;}.ssr-plugin'
import '.hr{border:1px solid var(--gray-200);}.ssr-plugin'
import '.hs{max-width:12rem;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.g6{background:none;}.ssr-plugin'
import '.bw{color:var(--gray-300);}.ssr-plugin'
import '.fc{width:1rem;}.ssr-plugin'
import '.fd{height:1rem;}.ssr-plugin'
import '.ej{gap:0.25rem;}.ssr-plugin'
import '.ek{color:var(--brand-primary);}.ssr-plugin'
import '.ht{padding:0.25rem;}.ssr-plugin'
import '.hu{color:var(--gray-400);}.ssr-plugin'
import '.hv{margin-top:1.5rem;}.ssr-plugin'
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useClient, useQuery, useAuthState } from '@based/sdk/react'
import { styled } from 'inlines'
import Column from '@app/components/layout/Column'
import Row from '@app/components/layout/Row'
import { Drawer } from '@app/components/blocks/drawer/Drawer'
import { MultiLineTextInput } from '@app/components/core/input/text/MultiLineTextInput'
import { FileSelector } from '@app/components/core/input/text/FileSelector'
import { TextInput } from '@app/components/core/input/text/TextInput'
import { Select } from '@app/components/core/input/select/Select'
import { Button } from '@app/components/core/button/Button'
import { Text } from '@app/components/core/typography/Text'
import { Tag } from '@app/components/core/tag/Tag'
import { Tooltip } from '@app/components/core/tooltip/Tooltip'
import { Alert } from '@app/components/core/alert/Alert'
import {
  SearchSelect,
  SearchSelectOption,
} from '@app/components/core/input/searchSelect/SearchSelect'
import { useTranslations } from '@i18n/useLanguage'
import { enrich } from '@i18n/localizeHelper'
import { useAuthModal } from '@app/util/hooks/useAuthModal'
import { MAX_POST_MESSAGE_LENGTH } from './constants'
import { UserAdminInitiative } from 'functions/app/plot/list-user-admin-initiatives'
import { GlobalPostViewModel } from 'functions/app/thread/view-global'
import { PostCategory } from '@schema/postCategory'
import { collectEntities } from '@app/pages/discussions/discussionsHelpers'
import { faPaperclip, faXmark } from '@fortawesome/pro-regular-svg-icons'
import { faImage, faFilePdf, faFile } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const MIN_TITLE_LENGTH = 3
const MAX_TITLE_LENGTH = 120
const MIN_MESSAGE_LENGTH = 80
const MAX_MEDIA_FILES = 5

type ExistingMediaItem = {
  id: number
  src: string
  mimeType?: string
  name?: string
}

export type CreatePostDrawerProps = {
  open: boolean
  onClose: () => void
  editPost?: GlobalPostViewModel | null
  // 'global' (default) = editing from the global discussions page.
  // 'thread' = editing from inside an entity's own discussion thread.
  context?: 'global' | 'thread'
  // When set, new posts are directed to this specific thread (hides location /
  // admin / elsewhere UI since the destination is fixed).
  threadId?: number
}

type PostCategoryOption = Pick<
  PostCategory,
  'id' | 'name' | 'primaryColour' | 'secondaryColour' | 'backgroundColour'
>

// Region and municipality are no longer destination-type options — location is
// handled separately via the municipality autocomplete.
type DestinationType = 'initiative' | 'housingForm' | 'plot'

const DESTINATION_QUERY: Record<DestinationType, string> = {
  initiative: 'list-user-initiatives',
  housingForm: 'list-followed-housing-form',
  plot: 'list-user-plots',
}

type FollowedEntity = { id: number; title?: string; name?: string }

type LocationType = 'municipality' | 'region'

type MunicipalitySuggestion = {
  id: number
  name: string
  crowdbuildingPartner?: boolean
  region?: { name?: string; crowdbuildingPartner?: boolean }
}

type RegionSuggestion = {
  id: number
  name: string
  crowdbuildingPartner?: boolean
}

const ToggleSwitch = ({
  active,
  onToggle,
}: {
  active: boolean
  onToggle: () => void
}) => (
  <button className="hh ex fj ay ac a1 p af"
    type="button"
    onClick={onToggle}
    style={{
      backgroundColor: active ? 'var(--brand-primary)' : 'var(--gray-200)',}}
  >
    <span className="be hi gn go gp v hj"
      style={{
        left: active ? '1.375rem' : '0.125rem',}}
    />
  </button>
)

export const CreatePostDrawer = ({
  open,
  onClose,
  editPost,
  context = 'global',
  threadId,
}: CreatePostDrawerProps) => {
  const t = useTranslations().app.discussions.createPost
  const client = useClient()
  const authState = useAuthState()
  const { withAuthCheck } = useAuthModal()

  const isEditMode = !!editPost
  // When threadId is provided we post directly to that thread — no destination
  // pickers or location fields are needed.
  const isThreadMode = !!threadId && !isEditMode

  // --- form state ---
  const [title, setTitle] = useState('')
  const [message, setMessage] = useState('')
  const [selectedCategoryIds, setSelectedCategoryIds] = useState<number[]>([])
  const [postMedia, setPostMedia] = useState<File[]>([])
  // Existing media files (edit mode): files already attached to the post.
  // Removing an item from this list schedules it for deletion on save.
  const [existingMedia, setExistingMedia] = useState<ExistingMediaItem[]>([])
  const [submitAttempted, setSubmitAttempted] = useState(false)

  // Location: municipality or region (municipality posts also link the region thread)
  const [selectedLocation, setSelectedLocation] =
    useState<SearchSelectOption | null>(null)
  const [selectedLocationType, setSelectedLocationType] =
    useState<LocationType | null>(null)
  const [locationQuery, setLocationQuery] = useState('')
  const [locationOptions, setLocationOptions] = useState<SearchSelectOption[]>(
    [],
  )
  const [showLocationNotFound, setShowLocationNotFound] = useState(false)
  const [locationIsInactive, setLocationIsInactive] = useState(false)
  // Track the last confirmed query string to avoid re-searching when the
  // user has already picked an option and the input text matches it.
  const confirmedLocationRef = useRef<string>('')
  // Store raw suggestions so we can check crowdbuildingPartner on selection.
  const locationSuggestionsRef = useRef<MunicipalitySuggestion[]>([])
  const regionSuggestionsRef = useRef<RegionSuggestion[]>([])
  // True when the user explicitly cleared the location so the edit-mode
  // fallback doesn't re-add the original geographic thread on save.
  const locationExplicitlyClearedRef = useRef(false)
  // Guards the edit-mode init so it fires exactly once per open/editPost pair.
  const initializedRef = useRef(false)

  // Destination: initiative / housingForm / plot the user is connected to
  const [postAsAdmin, setPostAsAdmin] = useState(false)
  const [selectedInitiativeId, setSelectedInitiativeId] = useState<
    number | null
  >(null)
  const [postElsewhere, setPostElsewhere] = useState(false)
  const [destinationType, setDestinationType] =
    useState<DestinationType | null>(null)
  const [selectedDestinationId, setSelectedDestinationId] = useState<
    number | null
  >(null)
  const [isSubmitting, setIsSubmitting] = useState(false)

  // Queries — declared here so the edit-init effect can read initiativesQuery.loading
  // and initiativeOptions before the first render cycle completes.
  const userId = authState.userId ? Number(authState.userId) : null

  const { data: categories = [] } = useQuery('list-post-categories')
  const initiativesQuery = useQuery(
    'list-user-admin-initiatives',
    userId ? { userId } : null,
  )
  const { data: destinationEntities = [] } = useQuery(
    destinationType ? DESTINATION_QUERY[destinationType] : 'list-post-categories',
    postElsewhere && destinationType && userId ? { userId } : null,
  )

  const categoryOptions = useMemo(
    () => (Array.isArray(categories) ? categories : []) as PostCategoryOption[],
    [categories],
  )

  const initiativeOptions = useMemo(
    () =>
      (Array.isArray(initiativesQuery.data) ? initiativesQuery.data : []) as UserAdminInitiative[],
    [initiativesQuery.data],
  )

  const destinationOptions = useMemo(
    () =>
      (Array.isArray(destinationEntities)
        ? destinationEntities
        : []) as FollowedEntity[],
    [destinationEntities],
  )

  // Reset the init guard whenever the drawer closes so the next open always
  // re-initializes from fresh thread data.
  useEffect(() => {
    if (!open) {
      initializedRef.current = false
    }
  }, [open])

  // Pre-populate form when opening in edit mode.
  // Gated on the admin-initiatives query finishing so the initiative
  // admin-vs-follow decision uses real data (not an empty list).
  useEffect(() => {
    if (!open || !editPost || initializedRef.current) {
      return
    }

    const entities = collectEntities(editPost.threads)

    // If the post links an initiative and we haven't yet loaded which
    // initiatives the user administers, defer until that query settles.
    if (entities.initiative?.id && initiativesQuery.loading) {
      return
    }

    initializedRef.current = true
    setSubmitAttempted(false)
    locationExplicitlyClearedRef.current = false

    setTitle(editPost.title ?? '')
    setMessage(editPost.content ?? '')
    setSelectedCategoryIds((editPost.categories ?? []).map((c) => c.id))
    setExistingMedia(
      (editPost.media ?? [])
        .filter((m) => m.status === 'ready' && m.id)
        .map((m) => ({ id: m.id, src: m.src, mimeType: m.mimeType, name: m.name })),
    )

    // Restore location: prefer "Municipality, Region" format so it matches
    // the suggestion label the backend produces for the search-select.
    // Region-only posts (e.g. created on a regional thread page) show the
    // province name directly.
    if (entities.municipality?.id) {
      const label = entities.region?.name
        ? `${entities.municipality.name}, ${entities.region.name}`
        : (entities.municipality.name ?? '')
      confirmedLocationRef.current = label
      setSelectedLocation({ key: entities.municipality.id, value: label })
      setSelectedLocationType('municipality')
      setLocationQuery(label)
    } else if (entities.region?.id) {
      const label = entities.region.name ?? ''
      confirmedLocationRef.current = label
      setSelectedLocation({ key: entities.region.id, value: label })
      setSelectedLocationType('region')
      setLocationQuery(label)
    } else {
      confirmedLocationRef.current = ''
      setSelectedLocation(null)
      setSelectedLocationType(null)
      setLocationQuery('')
    }

    if (context === 'thread') {
      // Thread context: the entity whose thread this post lives in is always
      // surfaced as "post it also elsewhere" — not as "post as admin".
      setPostAsAdmin(false)
      setSelectedInitiativeId(null)

      if (entities.initiative?.id) {
        setPostElsewhere(true)
        setDestinationType('initiative')
        setSelectedDestinationId(entities.initiative.id)
      } else if (entities.plot?.id) {
        setPostElsewhere(true)
        setDestinationType('plot')
        setSelectedDestinationId(entities.plot.id)
      } else if (entities.housingForm?.id) {
        setPostElsewhere(true)
        setDestinationType('housingForm')
        setSelectedDestinationId(entities.housingForm.id)
      } else {
        setPostElsewhere(false)
        setDestinationType(null)
        setSelectedDestinationId(null)
      }
    } else {
      // Global context: disambiguate initiative by admin membership.
      // If the user administers it → "Post as admin"; otherwise → "Post it
      // also elsewhere" so the entity can still be displayed and saved.
      if (entities.initiative?.id) {
        const isAdmin = initiativeOptions.some(
          (opt) => opt.id === entities.initiative.id,
        )
        if (isAdmin) {
          setPostAsAdmin(true)
          setSelectedInitiativeId(entities.initiative.id)
          setPostElsewhere(false)
          setDestinationType(null)
          setSelectedDestinationId(null)
        } else {
          setPostAsAdmin(false)
          setSelectedInitiativeId(null)
          setPostElsewhere(true)
          setDestinationType('initiative')
          setSelectedDestinationId(entities.initiative.id)
        }
      } else {
        setPostAsAdmin(false)
        setSelectedInitiativeId(null)
      }

      // plot / housingForm → always "post it also elsewhere"
      if (entities.plot?.id) {
        setPostElsewhere(true)
        setDestinationType('plot')
        setSelectedDestinationId(entities.plot.id)
      } else if (entities.housingForm?.id) {
        setPostElsewhere(true)
        setDestinationType('housingForm')
        setSelectedDestinationId(entities.housingForm.id)
      } else if (!entities.initiative?.id) {
        // Only reset these if we didn't already set them via initiative above.
        setPostElsewhere(false)
        setDestinationType(null)
        setSelectedDestinationId(null)
      }
    }
  }, [open, editPost, context, initiativeOptions, initiativesQuery.loading])

  // Fetch municipality suggestions whenever the locationQuery changes, as long
  // as the user is actually typing (not just viewing a confirmed selection).
  useEffect(() => {
    if (locationQuery === confirmedLocationRef.current) {
      setLocationOptions([])
      setShowLocationNotFound(false)
      return
    }

    if (!locationQuery.trim()) {
      setLocationOptions([])
      setShowLocationNotFound(false)
      return
    }

    let municipalityOptions: SearchSelectOption[] = []
    let regionOptions: SearchSelectOption[] = []

    const updateOptions = () => {
      const options = [...municipalityOptions, ...regionOptions]
      setLocationOptions(options)
      setShowLocationNotFound(options.length === 0)
    }

    const unsubMunicipality = client
      .query('suggestions-municipality', { searchTerm: locationQuery, top: 7 })
      .subscribe((results: MunicipalitySuggestion[]) => {
        locationSuggestionsRef.current = results
        municipalityOptions = results.map((m) => ({
          key: m.id,
          value: m.region?.name ? `${m.name}, ${m.region.name}` : m.name,
        }))
        updateOptions()
      })

    const unsubRegion = client
      .query('suggestions-region', { searchTerm: locationQuery, top: 7 })
      .subscribe((results: RegionSuggestion[]) => {
        regionSuggestionsRef.current = results
        regionOptions = results.map((r) => ({
          key: r.id,
          value: r.name,
        }))
        updateOptions()
      })

    return () => {
      unsubMunicipality()
      unsubRegion()
    }
  }, [client, locationQuery])

  const selectLocation = useCallback((option: SearchSelectOption) => {
    confirmedLocationRef.current = option.value
    setSelectedLocation(option)
    setLocationQuery(option.value)
    setLocationOptions([])
    setShowLocationNotFound(false)

    const municipalitySuggestion = locationSuggestionsRef.current.find(
      (s) =>
        s.id === option.key &&
        (s.region?.name ? `${s.name}, ${s.region.name}` : s.name) ===
          option.value,
    )
    if (municipalitySuggestion) {
      setSelectedLocationType('municipality')
      setLocationIsInactive(
        municipalitySuggestion.crowdbuildingPartner === false ||
          municipalitySuggestion.region?.crowdbuildingPartner === false,
      )
      return
    }

    const regionSuggestion = regionSuggestionsRef.current.find(
      (s) => s.id === option.key && s.name === option.value,
    )
    setSelectedLocationType('region')
    setLocationIsInactive(regionSuggestion?.crowdbuildingPartner === false)
  }, [])

  const abandonLocationSelection = useCallback(() => {
    setLocationQuery(confirmedLocationRef.current)
    setLocationOptions([])
    setShowLocationNotFound(false)
  }, [])

  const clearLocation = useCallback(() => {
    confirmedLocationRef.current = ''
    locationExplicitlyClearedRef.current = true
    setSelectedLocation(null)
    setSelectedLocationType(null)
    setLocationQuery('')
    setLocationOptions([])
    setShowLocationNotFound(false)
    setLocationIsInactive(false)
  }, [])

  const resolvedAdminInitiativeId =
    initiativeOptions.length === 1
      ? initiativeOptions[0].id
      : selectedInitiativeId

  const enablePostAsAdmin = useCallback(() => {
    setPostAsAdmin((prev) => {
      const next = !prev
      if (!next) {
        setSelectedInitiativeId(null)
      }
      return next
    })
  }, [])

  const enablePostElsewhere = useCallback(() => {
    setPostElsewhere((prev) => {
      const next = !prev
      if (!next) {
        setDestinationType(null)
        setSelectedDestinationId(null)
      }
      return next
    })
  }, [])

  const resetForm = useCallback(() => {
    setTitle('')
    setMessage('')
    setSelectedCategoryIds([])
    setPostMedia([])
    setExistingMedia([])
    setSubmitAttempted(false)
    confirmedLocationRef.current = ''
    locationExplicitlyClearedRef.current = false
    initializedRef.current = false
    setSelectedLocation(null)
    setSelectedLocationType(null)
    setLocationQuery('')
    setLocationOptions([])
    setShowLocationNotFound(false)
    setPostAsAdmin(false)
    setSelectedInitiativeId(null)
    setPostElsewhere(false)
    setDestinationType(null)
    setSelectedDestinationId(null)
    setLocationIsInactive(false)
  }, [])

  const handleClose = useCallback(() => {
    resetForm()
    onClose()
  }, [onClose, resetForm])

  const toggleCategory = (categoryId: number) => {
    setSelectedCategoryIds((prev) =>
      prev.includes(categoryId)
        ? prev.filter((id) => id !== categoryId)
        : [...prev, categoryId],
    )
  }

  const uploadFiles = useCallback(
    (postId: number) => {
      postMedia.forEach((file) => {
        void client.stream('upload-file', {
          mimeType: file.type,
          contents: file,
          size: file.size,
          fileName: file.name,
          payload: { postMedia: { id: postId } },
        })
      })
    },
    [client, postMedia],
  )

  // Builds the list of thread destinations from the active state.
  // Location (municipality) and both destination toggles can all be active at
  // once. In edit mode, geographic threads that weren't explicitly cleared are
  // preserved by falling back to the interrogated thread data — so location is
  // never dropped even if the SearchSelect field hasn't fully re-hydrated.
  const buildDestinations = (): { type: string; id: number }[] => {
    const destinations: { type: string; id: number }[] = []

    if (selectedLocation && selectedLocationType) {
      destinations.push({ type: selectedLocationType, id: selectedLocation.key })
    } else if (isEditMode && editPost && !locationExplicitlyClearedRef.current) {
      // Use collectEntities as the canonical source so we always read the same
      // entity fields regardless of how the thread data was serialised.
      const { municipality, region } = collectEntities(editPost.threads)
      if (municipality?.id) {
        destinations.push({ type: 'municipality', id: municipality.id })
      } else if (region?.id) {
        destinations.push({ type: 'region', id: region.id })
      }
    }

    if (postAsAdmin && resolvedAdminInitiativeId) {
      destinations.push({ type: 'initiative', id: resolvedAdminInitiativeId })
    }
    if (postElsewhere && destinationType && selectedDestinationId) {
      destinations.push({ type: destinationType, id: selectedDestinationId })
    }
    return destinations
  }

  const handleSubmit = () => {
    void withAuthCheck(async () => {
      setSubmitAttempted(true)

      const trimmedTitle = title.trim()
      const trimmed = message.trim()

      if (trimmedTitle.length < MIN_TITLE_LENGTH) {
        return
      }

      if (selectedCategoryIds.length === 0) {
        return
      }

      if (!isThreadMode && postElsewhere && (!destinationType || !selectedDestinationId)) {
        return
      }

      if (!isThreadMode && postAsAdmin && !resolvedAdminInitiativeId) {
        return
      }

      if (trimmed.length < MIN_MESSAGE_LENGTH) {
        return
      }

      if (isEditMode && editPost) {
        const destinations = buildDestinations()
        setIsSubmitting(true)
        try {
          await client.call('edit-post', {
            id: editPost.id,
            title: trimmedTitle,
            content: trimmed,
            categoryIds:
              selectedCategoryIds.length > 0 ? selectedCategoryIds : undefined,
            destinations,
            visibility: true,
          })
          // Delete media files the user removed (fire-and-forget).
          const removedFileIds = (editPost.media ?? [])
            .filter((m) => m.status === 'ready' && m.id)
            .filter((m) => !existingMedia.some((e) => e.id === m.id))
            .map((m) => m.id)
          removedFileIds.forEach((fileId) => {
            void client.call('delete-file', { fileId })
          })
          // Upload any newly added files.
          uploadFiles(editPost.id)
          handleClose()
        } finally {
          setIsSubmitting(false)
        }
        return
      }

      setIsSubmitting(true)
      try {
        if (isThreadMode) {
          // Post directly to the specified thread.
          const result = await client.call('add-post', {
            threadId,
            title: trimmedTitle,
            content: trimmed,
            categoryIds:
              selectedCategoryIds.length > 0 ? selectedCategoryIds : undefined,
            visibility: true,
          })
          if (result) {
            uploadFiles(Number(result))
          }
        } else {
          const destinations = buildDestinations()
          const result = await client.call('add-post', {
            title: trimmedTitle,
            content: trimmed,
            categoryIds:
              selectedCategoryIds.length > 0 ? selectedCategoryIds : undefined,
            destinations: destinations.length > 0 ? destinations : undefined,
            visibility: true,
          })
          if (result) {
            uploadFiles(Number(result))
          }
        }

        handleClose()
      } finally {
        setIsSubmitting(false)
      }
    })
  }

  // In edit mode, the destination entity from the original post may not yet be
  // included in the fetched options (e.g. async query still loading, or the
  // user only has admin access and doesn't follow the entity). Derive a
  // synthetic option directly from collectEntities so the Select renders the
  // correct label immediately without depending on load ordering.
  const editEntities = useMemo(
    () => (isEditMode && editPost ? collectEntities(editPost.threads) : null),
    [isEditMode, editPost],
  )

  const destinationOptionsWithFallback = useMemo((): FollowedEntity[] => {
    if (!isEditMode || !selectedDestinationId || !destinationType || !editEntities) {
      return destinationOptions
    }
    const alreadyInOptions = destinationOptions.some(
      (o) => o.id === selectedDestinationId,
    )
    if (alreadyInOptions) return destinationOptions

    const fallbackLabel =
      destinationType === 'initiative'
        ? editEntities.initiative?.title
        : destinationType === 'plot'
          ? editEntities.plot?.name
          : destinationType === 'housingForm'
            ? editEntities.housingForm?.title
            : undefined
    if (!fallbackLabel) return destinationOptions
    return [{ id: selectedDestinationId, title: fallbackLabel }, ...destinationOptions]
  }, [isEditMode, editEntities, destinationOptions, destinationType, selectedDestinationId])

  // When editing a post whose initiative link was saved as "post as admin",
  // the admin-initiatives list may not yet contain the entity (async load) or
  // the user's admin role may have changed. Build a synthetic option from the
  // thread context so the initiative Select always shows the correct label.
  const initiativeOptionsWithFallback = useMemo((): UserAdminInitiative[] => {
    if (!isEditMode || !editEntities?.initiative?.id || !postAsAdmin) {
      return initiativeOptions
    }
    const alreadyInOptions = initiativeOptions.some(
      (o) => o.id === editEntities.initiative.id,
    )
    if (alreadyInOptions) return initiativeOptions
    const fallback = editEntities.initiative
    if (!fallback?.title) return initiativeOptions
    return [{ id: fallback.id, title: fallback.title, description: '' }, ...initiativeOptions]
  }, [isEditMode, editEntities, initiativeOptions, postAsAdmin])

  const trimmedTitle = title.trim()
  const isTitleTooShort = trimmedTitle.length < MIN_TITLE_LENGTH
  const titleMinLengthError = enrich(t.titleMinLength, MIN_TITLE_LENGTH)
  const isMessageTooShort = message.trim().length < MIN_MESSAGE_LENGTH
  const messageMinLengthError = enrich(t.messageMinLength, MIN_MESSAGE_LENGTH)
  const isSubmitDisabled =
    isSubmitting || isTitleTooShort || isMessageTooShort

  return (
    <Drawer
      open={open}
      setOpen={(isOpen) => {
        if (!isOpen) {
          handleClose()
        }
      }}
      side="left"
      title={isEditMode ? t.editTitle : t.title}
      style={{ maxWidth: '28rem', borderRadius: '0 1.25rem 1.25rem 0' }}
    >
      <Column gap="1.5rem" alignItems="stretch">
        <TextInput
          label={t.titleLabel}
          text={title}
          setText={(value) => setTitle(value.slice(0, MAX_TITLE_LENGTH))}
          placeholder={t.titlePlaceholder}
          required={true}
          maxLength={MAX_TITLE_LENGTH}
          errorMessage={
            submitAttempted
              ? trimmedTitle.length === 0
                ? t.titleRequired
                : isTitleTooShort
                  ? titleMinLengthError
                  : undefined
              : undefined
          }
        />

        <Column gap="0.5rem" alignItems="stretch">
          <MultiLineTextInput
            label={t.messageLabel}
            value={message}
            setValue={(value) =>
              setMessage(value.slice(0, MAX_POST_MESSAGE_LENGTH))
            }
            placeholder={t.messagePlaceholder}
            minHeight="8rem"
            required={true}
            maxLength={MAX_POST_MESSAGE_LENGTH}
            maxLengthMessage={t.maxCharactersReached}
            errorMessage={
              submitAttempted && isMessageTooShort
                ? messageMinLengthError
                : undefined
            }
          />
        </Column>

        {/* Attach button — available in both create and edit mode */}
        {(existingMedia.length + postMedia.length) < MAX_MEDIA_FILES && (
        <styled.label className="cb s t ai u fz du hk hl hm hn ho a3 ct hp cq a1"
          style={{
            '&:hover': {
              background: 'var(--brand-secondary)',
              color: 'var(--palette-white)',
            },
            '&:active': {
              background: 'var(--brand-secondary)',
              color: 'var(--palette-white)',
            },
          }}
        >
          <FileSelector
            icon={faPaperclip}
            filesSelected={existingMedia.length + postMedia.length}
            maxFiles={MAX_MEDIA_FILES - existingMedia.length}
            allowedFileTypes={[
              'image/jpeg',
              'image/png',
              'image/webp',
              'application/pdf',
            ]}
            onFileSelectionUpdated={(newFiles) => {
              setPostMedia((prev) => {
                const combined = [...prev, ...newFiles]
                const seen = new Set<string>()
                const deduped = combined.filter((file) => {
                  const key = `${file.name}-${file.size}`
                  if (seen.has(key)) return false
                  seen.add(key)
                  return true
                })
                return deduped.slice(0, MAX_MEDIA_FILES - existingMedia.length)
              })
            }}
            iconStyle={{ color: 'currentColor' }}
          />
          <span className="b4">{t.attachLabel}</span>
        </styled.label>
        )}

        {/* File chips: existing (edit mode) + newly added */}
        {(isEditMode ? existingMedia.length + postMedia.length : postMedia.length) > 0 && (
          <Row gap="0.5rem" style={{ flexWrap: 'wrap' }}>
            {/* Existing media chips (edit mode only) */}
            {isEditMode && existingMedia.map((item) => {
              const isPdf = item.mimeType === 'application/pdf'
              const isImage = item.mimeType?.startsWith('image/') ?? false
              const icon = isPdf ? faFilePdf : isImage ? faImage : faFile
              return (
                <div className="cb t ef hq fa hr v hs"
                  key={item.id}
                >
                  <FontAwesomeIcon
                    icon={icon}
                    style={{
                      width: '0.875rem',
                      height: '0.875rem',
                      color: isPdf ? 'var(--palette-red-400)' : 'var(--brand-secondary)',
                      flexShrink: 0,
                    }}
                  />
                  <Text.Small
                    style={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      color: 'var(--brand-secondary)',
                    }}
                  >
                    {item.name ?? item.src.split('/').pop()}
                  </Text.Small>
                  <button className="d t ai af g6 ay p a1 bw fc fd"
                    type="button"
                    onClick={() =>
                      setExistingMedia((prev) => prev.filter((e) => e.id !== item.id))
                    }
                  >
                    <FontAwesomeIcon
                      icon={faXmark}
                      style={{ width: '0.75rem', height: '0.75rem' }}
                    />
                  </button>
                </div>
              )
            })}
            {/* Newly added file chips */}
            {postMedia.map((file, index) => {
              const isPdf = file.type === 'application/pdf'
              const isImage = file.type.startsWith('image/')
              const icon = isPdf ? faFilePdf : isImage ? faImage : faFile

              return (
                <div className="cb t ef hq fa hr v hs"
                  key={`${file.name}-${file.lastModified}`}
                >
                  <FontAwesomeIcon
                    icon={icon}
                    style={{
                      width: '0.875rem',
                      height: '0.875rem',
                      color: isPdf ? 'var(--palette-red-400)' : 'var(--brand-secondary)',
                      flexShrink: 0,
                    }}
                  />
                  <Text.Small
                    style={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      color: 'var(--brand-secondary)',
                    }}
                  >
                    {file.name}
                  </Text.Small>
                  <button className="d t ai af g6 ay p a1 bw fc fd"
                    type="button"
                    onClick={() =>
                      setPostMedia((prev) => prev.filter((_, i) => i !== index))
                    }
                  >
                    <FontAwesomeIcon
                      icon={faXmark}
                      style={{ width: '0.75rem', height: '0.75rem' }}
                    />
                  </button>
                </div>
              )
            })}
          </Row>
        )}

        <Column gap="0.75rem" alignItems="stretch">
          <div className="d t ej">
            <Text.Medium style={{ color: 'var(--palette-blue-500)' }}>{t.tagsLabel}</Text.Medium>
            <span className="ek">*</span>
          </div>
          <Row gap="0.5rem" style={{ flexWrap: 'wrap' }}>
            {categoryOptions.map((category) => {
              const isSelected = selectedCategoryIds.includes(category.id)
              return (
                <Tag
                  key={category.id}
                  label={category.name}
                  variant="accent"
                  size="small"
                  onClick={() => toggleCategory(category.id)}
                  style={{
                    border: `1px solid ${isSelected ? category.primaryColour : 'var(--gray-200)'}`,
                    backgroundColor: isSelected
                      ? category.primaryColour
                      : 'var(--palette-white)',
                  }}
                />
              )
            })}
          </Row>
          {submitAttempted && selectedCategoryIds.length === 0 && (
            <Text.FormError>{t.categoryRequired}</Text.FormError>
          )}
        </Column>

        {/* Location and destination pickers — hidden in thread mode */}
        {!isThreadMode && (
          <>
            <Column gap="0.5rem" alignItems="stretch">
              <Row
                gap="0.5rem"
                style={{ alignItems: 'center', justifyContent: 'space-between' }}
              >
                <SearchSelect
                  label={t.locationLabel}
                  placeholder={t.locationPlaceholder}
                  value={locationQuery}
                  setValue={(v) => {
                    setLocationQuery(v)
                    if (selectedLocation && v !== confirmedLocationRef.current) {
                      setSelectedLocation(null)
                      setSelectedLocationType(null)
                      confirmedLocationRef.current = ''
                      setLocationIsInactive(false)
                    }
                  }}
                  selectOption={selectLocation}
                  abandonSelection={abandonLocationSelection}
                  options={locationOptions}
                  noResultsMessage={{
                    display: showLocationNotFound,
                    message: t.locationNotFound,
                  }}
                />
                {selectedLocation && (
                  <button className="d t ai g6 ay ht a1 hu af hv"
                    type="button"
                    onClick={clearLocation}
                    aria-label="Clear location"
                  >
                    <FontAwesomeIcon
                      icon={faXmark}
                      style={{ width: '0.875rem', height: '0.875rem' }}
                    />
                  </button>
                )}
              </Row>
              {locationIsInactive && (
                <Alert
                  variant="info"
                  size="small"
                  message={t.locationInactiveMessage}
                />
              )}
            </Column>

            {context !== 'thread' && initiativeOptions.length >= 1 && (
              <Column gap="0.75rem" alignItems="stretch">
                <Row gap="0.75rem" style={{ alignItems: 'center' }}>
                  <ToggleSwitch active={postAsAdmin} onToggle={enablePostAsAdmin} />
                  <Text.Medium>{t.postAsAdminLabel}</Text.Medium>
                  <Tooltip content={t.postAsAdminTooltip} style={{ maxWidth: '18rem' }} />
                </Row>
                {postAsAdmin && initiativeOptions.length >= 2 && (
                  <Select
                    label={t.initiativeLabel}
                    value={selectedInitiativeId}
                    setValue={setSelectedInitiativeId}
                    options={initiativeOptionsWithFallback.map((initiative) => ({
                      value: initiative.id,
                      label: initiative.title,
                    }))}
                    notSelectedLabel={t.initiativePlaceholder}
                  />
                )}
              </Column>
            )}

            <Column gap="0.75rem" alignItems="stretch">
              <Row gap="16px" style={{ alignItems: 'center' }}>
                <ToggleSwitch
                  active={postElsewhere}
                  onToggle={enablePostElsewhere}
                />
                <Row gap="8px" style={{ alignItems: 'center' }}>
                  <Text.Medium>{t.postElsewhereLabel}</Text.Medium>
                  <Tooltip content={t.postElsewhereTooltip} style={{ maxWidth: '18rem' }} />
                </Row>
              </Row>
              {postElsewhere && (
                <Column gap="0.75rem" alignItems="stretch">
                  <Select
                    label={t.destinationTypeLabel}
                    value={destinationType}
                    setValue={(value) => {
                      setDestinationType(value)
                      setSelectedDestinationId(null)
                    }}
                    options={[
                      { value: 'initiative', label: t.typeInitiative },
                      { value: 'housingForm', label: t.typeHousingForm },
                      { value: 'plot', label: t.typePlot },
                    ]}
                    notSelectedLabel={t.destinationTypePlaceholder}
                  />
                  {destinationType && (
                    <Select
                      label={t.destinationLabel}
                      value={selectedDestinationId}
                      setValue={setSelectedDestinationId}
                      options={destinationOptionsWithFallback.map((entity) => ({
                        value: entity.id,
                        label: entity.title ?? entity.name ?? '',
                      }))}
                      notSelectedLabel={t.destinationPlaceholder}
                    />
                  )}
                </Column>
              )}
            </Column>
          </>
        )}

        <Row gap="0.75rem" style={{ marginTop: '0.5rem' }}>
          <Button
            variant="secondary"
            label={t.discard}
            onClick={handleClose}
            style={{ flex: 4 }}
          />
          {isMessageTooShort ? (
            <Tooltip
              content={messageMinLengthError}
              containerStyle={{ flex: 8, display: 'flex' }}
              style={{ maxWidth: '18rem' }}
            >
              <Button
                variant="primary"
                label={isEditMode ? t.saveChanges : t.placePost}
                onClick={handleSubmit}
                disabled={isSubmitDisabled}
                style={{ width: '100%' }}
              />
            </Tooltip>
          ) : (
            <Button
              variant="primary"
              label={isEditMode ? t.saveChanges : t.placePost}
              onClick={handleSubmit}
              disabled={isSubmitDisabled}
              style={{ flex: 8 }}
            />
          )}
        </Row>
      </Column>
    </Drawer>
  )
}
